




















































































































































































































































import { Component, Watch, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { LineValue } from '@/interfaces';
import formatting from '@/formatting';

@Component
export default class SiteDetail extends Mixins(DetailMixin) {
  public coordSrc: any = null;
  public coordDst: any = null;
  public tableCfg = FieldDefs;
  public disableEditDialogValue = false;

  public loaded(rec) {
    // Check if edit is allowed once the record is loaded (edit from overview)
    this.checkDisableEdit();
    this.setCoordsAvailable(rec);
  }

  public setCoordsAvailable(rec) {
    this.coordSrc = null;
    this.coordDst = null;
    for (const line of rec.sitelines) {
      if (line.name === 'GPS_1') {
        this.coordSrc = formatting.formatCoordinates(line.value);
      } else if (line.name === 'GPS_2') {
        this.coordDst = formatting.formatCoordinates(line.value);
      }
    }
  }

  public goBack() {
    const ref: any = this.$refs.layout;
    this.$router.push(ref.url + '/' + String(ref.rec.id));
    this.disableEditDialogValue = false;
  }

  public openServiceOrder(serviceorder) {
    const typeUrl = this.isSite() ? '/sites' : '/routecontrols';
    const serviceTypeUrl =
      serviceorder.service_type === 0 ? '/serviceorders' : '/notifications';
    const link = typeUrl + serviceTypeUrl + '/' + String(serviceorder.id);
    window.open(link, '_blank');
  }

  // Get lines of the selected site type
  public async getSiteTypeLines() {
    const ref: any = this.$refs.layout;
    const id = ref.rec.sitetype_id;
    if (id) {
      const response = await this.api.getLines(this.$store, '/sitetypes/' + id);
      if (response) {
        const lines: LineValue[] = [];
        for (const line of response.data.data) {
          const l: LineValue = {
            id: 0,
            sitetypeline_id: line.id,
            value: line.default,
            value_index: line.default_index,
            linedatatype: line.linedatatype,
            name: line.name,
            title_nl: line.title_nl,
            title_fr: line.title_fr,
            values_fr: line.values_fr,
            values_nl: line.values_nl
          };
          lines.push(l);
        }
        ref.rec.sitelines = lines;
        this.setCoordsAvailable(ref.rec);
        // Let detail layout component know that something changed
        ref.$refs.form.$emit('input');
      }
    }
  }

  public checkDisableEdit() {
    const ref: any = this.$refs.layout;
    if (
      this.$route.query.mode === 'edit' &&
      ref.rec &&
      ref.rec.serviceorders &&
      ref.rec.serviceorders.length > 0
    ) {
      // UNPROCESSED SERVICE ORDERS
      this.disableEditDialogValue = true;
    }
  }

  @Watch('$route.query.mode') public editChanged() {
    // Query mode changed, check if edit is allowed
    this.checkDisableEdit();
  }

  public mounted() {
    this.checkDisableEdit();
  }
}
